import { Tooltip, Typography } from '@mui/material';
import { IconLibrary } from '@product-framework/index';
import { useLocalization } from '@ui-framework/index';

function PasswordInstructions() {
  const { formatMessage } = useLocalization();

  const passwordValidationMessages = [
    formatMessage({
      id: 'MUST_CONTAIN_8_64_CHARACTERS',
      defaultMessage: 'Must contain 8-64 characters',
    }),
    formatMessage({
      id: 'MUST_CONTAIN_AT_LEAST_ONE_UPPERCASE_LETTER',
      defaultMessage: 'Must contain at least one uppercase letter',
    }),
    formatMessage({
      id: 'MUST_CONTAIN_AT_LEAST_ONE_NUMBER',
      defaultMessage: 'Must contain at least one number',
    }),
    formatMessage({
      id: 'PASSWORD_NOT_EQUAL_EMAIL',
      defaultMessage: 'Must not be the same as your email address',
    }),
  ];

  return (
    <Tooltip
      title={
        <>
          <Typography variant="subtitle2" gutterBottom>
            {formatMessage({
              id: 'PASSWORD_REQUIREMENTS',
              defaultMessage: 'Password Requirements',
            })}
          </Typography>
          <ul style={{ paddingLeft: '1.2em' }}>
            {passwordValidationMessages.map((msg, idx) => (
              <li key={msg || idx}>{msg}</li>
            ))}
          </ul>
        </>
      }
      arrow>
      <IconLibrary.Info color="info" sx={{ fontSize: 18, ml: 0.4, mb: -0.5 }} />
    </Tooltip>
  );
}

export default PasswordInstructions;
